import { hasDevisInstallateurRequis, getRegimeAides } from "./tenantProfile";

// Composition des étapes du wizard devis — DÉRIVÉE DES CAPACITÉS DÉCLARÉES du tenant,
// ⛔ jamais d'un slug ni du seul type de client.
//   · Installateur ⇐ `config.devis_installateur_requis`
//   · Aides        ⇐ `config.regime_aides` non vide (mpr / cee / anah)
// Client, Produits et Validation (Enregistrer) sont communes à tous.
//
// DETTE D'ARCHITECTURE (assumée, lot P0 devis Mario) : les identifiants d'étape restent
// les numéros historiques 1..5 ; une étape inactive est retirée de la séquence
// affichée, et sa validation vaut « ok ». Une composition déclarative complète
// (registre d'étapes par capacité) reste à faire.
export const ETAPE_CLIENT = 1;
export const ETAPE_PRODUITS = 2;
export const ETAPE_INSTALLATEUR = 3;
export const ETAPE_AIDES = 4;
export const ETAPE_VALIDATION = 5;

export function composerEtapesDevis({ installateurRequis = false, regimeAides = [] } = {}) {
  const ids = [ETAPE_CLIENT, ETAPE_PRODUITS];
  if (installateurRequis) ids.push(ETAPE_INSTALLATEUR);
  if (Array.isArray(regimeAides) && regimeAides.length > 0) ids.push(ETAPE_AIDES);
  ids.push(ETAPE_VALIDATION);
  return ids;
}

export function etapesDevisDuTenant() {
  return composerEtapesDevis({
    installateurRequis: hasDevisInstallateurRequis(),
    regimeAides: getRegimeAides(),
  });
}

export function etapeApres(ids, courante) {
  const i = ids.indexOf(courante);
  return i >= 0 && i < ids.length - 1 ? ids[i + 1] : null;
}

export function etapeAvant(ids, courante) {
  const i = ids.indexOf(courante);
  return i > 0 ? ids[i - 1] : null;
}

// Total d'une ligne = quantité × prix unitaire HT (arrondi au centime, comme le serveur).
export function totalLigneHt(quantite, prixUnitaireHt) {
  const q = Number(quantite);
  const pu = Number(prixUnitaireHt);
  if (!Number.isFinite(q) || !Number.isFinite(pu)) return 0;
  return Math.round(q * pu * 100) / 100;
}
